import GLOBAL from "@/Global";
import http, { parseAxiosError } from "@/service/http";

async function getInformeGeneral(person, fechainicio, fechafin, tipo, filtros = null) {

  try {

    const { data } = await http.get(GLOBAL.API_GET_REPORTE_VENTAS_SIIGO, {
      timeout: 30000,
      headers: {
        Authorization: `Basic ${person.token}`,
        Environment: person.empresas
      },
      params: {
        fechainicio: `${fechainicio}:00.000`,
        fechafin: `${fechafin}:59.999`,
        estado: tipo,
        ...(filtros && Object.keys(filtros).length && {
          search: JSON.stringify(filtros)
        })
      }
    });

    return data;

  } catch (error) {
    throw new Error(
      parseAxiosError(error, "No fue posible obtener el informe general.")
    );
  }
}

async function exportarInformeGeneral(person, fechainicio, fechafin, tipo) {

  try {

    return await http.get(GLOBAL.API_GET_REPORTE_VENTAS_SIIGO, {
      timeout: 0,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Basic ${person.token}`,
        Environment: person.empresas
      },
      params: {
        formato: "excel",
        fechainicio: `${fechainicio}:00.000`,
        fechafin: `${fechafin}:59.999`,
        estado: tipo
      }
    });

  } catch (error) {
    throw new Error(
      parseAxiosError(error, "No fue posible generar el archivo Excel.")
    );
  }
}

export default {
  getInformeGeneral,
  exportarInformeGeneral
};